/** 三类 Agent 的提交及报告操作引导统一使用的遮罩颜色。 */
export const ACTION_GUIDE_OVERLAY_COLOR = '#292929';

/** 三类 Agent 的提交及报告操作引导统一使用的遮罩透明度。 */
export const ACTION_GUIDE_OVERLAY_OPACITY = 0.54;
